/* hm-drawer: szuflada opinii (snippets/hm-rev-drawer.liquid). Wzorzec: RESILIA/…/makiety/_wspolne/hm-drawer.js (R5).
   Otwierają ją a[data-rev] i button[data-rev] z dowolnej sekcji: data-rev="all" albo klucz filtra (np. periods).
   Telefon: arkusz 50% → 90% (uchwyt, przeciągnięcie uchwytu/nagłówka, strzałki na uchwycie); komputer: panel z prawej.
   Wstecz zamyka (wpis historii PRZED blokadą tła, żeby zapamiętał prawdziwe scrollY); po zamknięciu strona wraca dokładnie
   w to samo miejsce, a fokus na przycisk, który otworzył szufladę. Bez szuflady na stronie link działa zwyczajnie (href). */
(function () {
  if (window.HMD) return;
  var dlg, grab, hdr, title, chips, cards, empty, body, MQ, RM;
  var lastFocus = null, closing = false, fromPop = false, pushed = false, lockY = 0, locked = false, drag = null;
  function isDesk() { return MQ.matches; }

  function setSize(s) {
    dlg.dataset.size = s;
    grab.setAttribute('aria-expanded', s === 'full');
    grab.setAttribute('aria-label', s === 'full' ? grab.dataset.shorter : grab.dataset.taller);
  }
  function filter(f) {
    if (!f || !dlg.querySelector('[data-hmd-f="' + f + '"]')) f = 'all';
    var any = false;
    chips.forEach(function (c) {
      var on = c.dataset.hmdF === f; c.setAttribute('aria-pressed', on);
      if (on) { var p = c.parentElement; p.scrollLeft = Math.max(0, c.offsetLeft - p.clientWidth / 2 + c.offsetWidth / 2); }
    });
    cards.forEach(function (r) { var on = f === 'all' || r.dataset.tags.indexOf(' ' + f + ' ') > -1; r.hidden = !on; if (on) any = true; });
    if (empty) empty.hidden = any;
    body.scrollTop = 0;
  }
  // blokada przewijania strony pod spodem (iOS Safari omija overflow:hidden): body fixed + zapis i przywrócenie scrollY
  function lock() {
    if (locked) return; locked = true; lockY = window.scrollY;
    var b = document.body.style; b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locked) return; locked = false;
    var b = document.body.style; b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    try { window.scrollTo({ top: lockY, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, lockY); }
  }
  function open(f) {
    if (dlg.dataset.custom) restore();
    filter(f);
    show();
  }
  /* Jedna treść w szufladzie (strona Reviews: pełna opinia z paska zdjęć). html składa wywołujący z bezpiecznych części. */
  var orig = null;
  function restore() {
    if (!orig) return; title.textContent = orig.t; if (orig.e) orig.e.el.textContent = orig.e.v; if (orig.s) orig.s.el.textContent = orig.s.v;
    if (orig.c) orig.c.hidden = false; if (orig.f) orig.f.hidden = false;
    var x = body.querySelector('.hmd-custom'); if (x) x.remove();
    [].slice.call(body.children).forEach(function (c) { if (c.dataset.hmdHid) { c.hidden = false; delete c.dataset.hmdHid; } });
    delete dlg.dataset.custom;
  }
  function openHTML(o) {
    var e = dlg.querySelector('.hmd-e'), s = dlg.querySelector('.hmd-s');
    if (!dlg.dataset.custom) {
      orig = { t: title.textContent, e: e && { el: e, v: e.textContent }, s: s && { el: s, v: s.textContent }, c: dlg.querySelector('.hmd-chips'), f: dlg.querySelector('.hmd-f:not(.hmd-back)') };
      [].slice.call(body.children).forEach(function (c) { if (!c.hidden) { c.hidden = true; c.dataset.hmdHid = '1'; } });
    }
    dlg.dataset.custom = '1';
    title.textContent = o.title || ''; if (e) e.textContent = o.eyebrow || ''; if (s) s.textContent = o.sub || '';
    if (orig.c) orig.c.hidden = true; if (orig.f) orig.f.hidden = true;
    var x = body.querySelector('.hmd-custom'); if (!x) { x = document.createElement('div'); x.className = 'hmd-custom'; body.appendChild(x); }
    x.innerHTML = o.html; body.scrollTop = 0;
    show();
  }
  function show() {
    if (dlg.open) return;
    lastFocus = document.activeElement; closing = false; setSize('half');
    try { history.pushState({ hmd: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    lock(); dlg.showModal();
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('in'); }); });
    try { title.focus({ preventScroll: true }); } catch (e) {}
  }
  function finish() {
    dlg.classList.remove('in'); dlg.style.height = '';
    if (dlg.open) dlg.close();
    unlock(); closing = false;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!dlg.open || closing) return;
    closing = true; dlg.classList.remove('in');
    if (RM) finish(); else setTimeout(finish, isDesk() ? 260 : 300);
  }

  function init() {
    dlg = document.querySelector('dialog[data-hmd]');
    if (!dlg || dlg.dataset.hmdInit) return;
    dlg.dataset.hmdInit = '1';
    MQ = matchMedia('(min-width: 960px)');
    RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    grab = dlg.querySelector('.hmd-grab'); hdr = dlg.querySelector('.hmd-h'); title = dlg.querySelector('h2');
    chips = [].slice.call(dlg.querySelectorAll('[data-hmd-f]')); cards = [].slice.call(dlg.querySelectorAll('.hmd-rv'));
    empty = dlg.querySelector('.hmd-empty'); body = dlg.querySelector('.hmd-body');

    dlg.addEventListener('close', function () { // przycisk, gest albo Esc: zdejmij wpis historii
      if (pushed && !fromPop && history.state && history.state.hmd) { pushed = false; history.back(); }
      pushed = false; fromPop = false;
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    window.addEventListener('popstate', function () { if (dlg.open) { fromPop = true; pushed = false; close(); } });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-hmd-close]')) { close(); return; }
      var c = e.target.closest('[data-hmd-f]'); if (c) filter(c.dataset.hmdF);
    });

    function down(e) {
      if (isDesk() || e.target.closest('[data-hmd-close]')) return;
      drag = { y: e.clientY, h: dlg.getBoundingClientRect().height, moved: false };
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (x) {}
      dlg.classList.add('drag');
    }
    function move(e) {
      if (!drag) return; var dy = e.clientY - drag.y; if (Math.abs(dy) > 5) drag.moved = true; if (!drag.moved) return;
      var vh = innerHeight; dlg.style.height = Math.min(vh * 0.92, Math.max(vh * 0.22, drag.h - dy)) + 'px';
    }
    function up(e) {
      if (!drag) return; var dy = e.clientY - drag.y, moved = drag.moved, half = dlg.dataset.size !== 'full';
      drag = null; dlg.classList.remove('drag'); dlg.style.height = '';
      if (!moved) { if (e.currentTarget === grab) setSize(half ? 'full' : 'half'); return; }
      if (half) { if (dy > 70) close(); else if (dy < -30) setSize('full'); }
      else { if (dy > 230) close(); else if (dy > 40) setSize('half'); }
    }
    [grab, hdr].forEach(function (el) {
      el.addEventListener('pointerdown', down); el.addEventListener('pointermove', move); el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', function () { drag = null; dlg.classList.remove('drag'); dlg.style.height = ''; });
    });
    grab.addEventListener('keydown', function (e) { if (e.key === 'ArrowUp') setSize('full'); if (e.key === 'ArrowDown') setSize('half'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[data-rev],button[data-rev]');
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    init();
    if (!dlg || (dlg.contains(t))) return;
    e.preventDefault();
    open(t.getAttribute('data-rev'));
  });
  document.addEventListener('shopify:section:load', function () { dlg = null; init(); });
  window.HMD = { open: function (f) { init(); if (dlg) open(f); }, openHTML: function (o) { init(); if (dlg) openHTML(o); }, close: function () { if (dlg) close(); } };
})();
